import type {
  TProductCategoryType,
  TSubCategoryType,
} from "@/shared/entitys/black5";
import { ProductCategoryType, SubCategoryType } from "@/shared/enums/black5";

export const ProductCategoryList: TProductCategoryType[] = [
  { name: "Discount Section", type: ProductCategoryType.Discount },
  { name: "Super Commission", type: ProductCategoryType.Commission },
  { name: "Low Price Hits", type: ProductCategoryType.Price },
  { name: "Discounted Products Category", type: ProductCategoryType.Category },
  { name: "Free Shipping Zone", type: ProductCategoryType.Shipping },
  { name: "More Discounted Products", type: ProductCategoryType.More },
];

export const SubCategoryTypeList: TSubCategoryType[] = [
  {
    name: "Beaut & Personal Care",
    id: SubCategoryType.Beaut,
  },
  {
    name: "Womenwear & Underwear",
    id: SubCategoryType.Womenwear,
  },
  {
    name: "Home Supplies",
    id: SubCategoryType.Home,
  },
  {
    name: "Phones & Electronics",
    id: SubCategoryType.Phones,
  },
];
